import Vue from 'vue'
import VueI18n from 'vue-i18n'
import es from '@/i18n/locales/es.json'
import en from '@/i18n/locales/en.json'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'es',
  fallbackLocale: 'es',
  messages: {
    es, en
  }
})

export default i18n
